import * as api from '../api';
import * as types from '../constants/actions';
import { makeAsyncAction } from '../../../ui-lottery/src/utils/async_utils';

export const fetchPassTypesByFacility = makeAsyncAction(
  types.FETCH_PASS_TYPES,
  (facilityId) => () => api.getPassTypesByFacility(facilityId),
  'pass_types'
);

export const fetchPassType = makeAsyncAction(
  types.FETCH_PASS_TYPE,
  (passTypeId) => () => api.getPassType(passTypeId),
  'pass_type'
);
